$(document).ready(function () {
  "use strict";
  // for Accordion start //
  if ($(".accordion").length > 0) {
    $('.accordion').click(function (e) {
      e.preventDefault();
      var $this = $(this);
      var elHeight = $this.next().prop('scrollHeight');
      console.log(elHeight); 

      if ($this.next().hasClass('active')) {
        $this.next().removeClass('active').css('height', 0);
        $this.removeClass('active');
        $this.parent().removeClass('active');
      } else {
        $this.parent().parent().find('.item-row .panel').removeClass('show').css('height', 0);
        $this.parent().parent().find('.item-row .accordion').removeClass('active');
        $this.parent().parent().find('.item-row').removeClass('active');
        $this.next().toggleClass('active').css('height', elHeight);
        $this.toggleClass('active');
        $this.parent().toggleClass('active');
      }
    });
  }
  // for Accordian end //

  // for Map Accordian start //
  if ($(".map-row").length > 0) {
    $('.map-row').click(function (e) {
      var $this = $(this);
      $this.next().toggleClass('active').slideToggle();
      $this.toggleClass('active');
    });
    $('.map-item').click(function (e) {
      var $this = $(this);
      var text = $this.html();
      console.log(text);
      $this.parents('.map-item-row').find('.map-row').html(text)
      $this.parent().removeClass('active').slideUp();

    });
  }
  // for Map Accordian end //

  // for mobile navigation start //
  if ($(window).width() < 1025) {

    $('.menu-toggle').on('click', function (e) {
      var $this = $(this);
      $this.toggleClass('open');
      $this.parent().parent().find('.right-section').toggleClass('active');
      $('body').toggleClass('overlay');
      if ($('.assist-bot-box-mobile').hasClass('active')) {
        $('.assist-bot-box-mobile').removeClass('active');
      }
      e.stopPropagation();
    });

    $(document).on("click tap", function (e) {
      var mobileNav = $('.right-section');
      var innerSectionOnMobileNav = $('.right-section *');
      if ((!($(e.target).is(mobileNav)) && !($(e.target).is(innerSectionOnMobileNav)) && mobileNav.hasClass('active'))) {
        mobileNav.removeClass('active');
        mobileNav.parent().parent().find('.left-section .menu-toggle').removeClass('open');
        $('body').removeClass('overlay');
        e.stopPropagation();
      }
    });

    if ($(".navigation").length > 0) {
      $('.navigation .toggel-event').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        var height = $this.next().prop('scrollHeight');

        if ($this.next().hasClass('active')) {
          $this.next().removeClass('active').css('height', 0);
          $this.removeClass('active');
          $this.parent().removeClass('active');
        } else {
          $this.parent().parent().find('>li .item-disc').removeClass('active').css('height', 0);
          $this.parent().parent().find('>li .toggel-event').removeClass('active');
          $this.parent().parent().find('>li').removeClass('active');
          $this.next().toggleClass('active').css('height', height);
          $this.toggleClass('active');
          $this.parent().toggleClass('active');
        }
      });
    }
  }
  // for mobile navigation end // 

  // for Search and Filter on Resort page start
  $('input.searchInput1').focus(function () {
    $(this).parents('.search-bar').removeClass('as-filter');
    $(this).parents('.search-bar').addClass('input-focus');
    $(this).parents('.search-bar').siblings('.search-suggestion').addClass('show');
    $(this).parents('.searchbar-with-countries').addClass('overlay');
    $('body').css('overflow', 'hidden');
  });

  $(document).on("click tap", function (e) {
    var el = $('.searchbar-with-countries >.container');
    var innerSectionOnEl = $('.searchbar-with-countries >.container *');
    if ((!($(e.target).is(el)) && !($(e.target).is(innerSectionOnEl)))) {
      $('.search-bar').removeClass('input-focus');
      $('.search-bar').siblings('.search-suggestion').removeClass('show');
      $('.searchbar-with-countries').removeClass('overlay');
      $('body').css('overflow', '');
      e.stopPropagation();
    }
  });
  // for Search and Filter on Resort page end

  // for Choose the dependent’s relation with you section on KYC start
  if ($(".relation-list").length > 0) {
    $('.relation-list').on('click', 'li', function (e) {
      e.preventDefault();
      var $this = $(this);
      var btn = document.querySelector('.btn-next');

      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.siblings().removeClass('active');
        $this.parent().parent().removeClass('active');
        $(btn).addClass('disabled');
      } else {
        $this.siblings().removeClass('active');
        $this.parent().parent().addClass('active');
        $(btn).removeClass('disabled');
        $this.toggleClass('active');
      }
    });
  }
  // for Choose the dependent’s relation with you section on KYC end

  // for Choose the Offer on Plan Purchase start
  if ($("#offer-sel-slider").length > 0) {
    $('#offer-sel-slider').on('click', '.slide', function (e) {
      // e.preventDefault();
      var $this = $(this);

      if ($this.hasClass('checked')) {
        $this.parent().siblings().removeClass('checked');
        $this.parent().siblings().find('.slide').removeClass('checked');
      } else {
        $this.parent().siblings().removeClass('checked');
        $this.parent().siblings().find('.slide').removeClass('checked');
        $this.parent().addClass('checked');
        $this.addClass('checked');
      }
    });
  }
  // for Choose the Plan on Plan Purchase end

  // for Choose the Plan on Plan Purchase start
  if ($(".plan-list").length > 0) {
    $('.plan-list').on('click', '.op-slide', function (e) {
      // e.preventDefault();
      var $this = $(this);

      if ($this.hasClass('checked')) {
        $this.parent().siblings().removeClass('checked');
        $this.parent().siblings().find('.op-slide').removeClass('checked');
      } else {
        $this.parent().siblings().removeClass('checked');
        $this.parent().siblings().find('.op-slide').removeClass('checked');
        $this.parent().addClass('checked');
        $this.addClass('checked');
      }
    });
  }
  // for Choose the Plan on Plan Purchase end

  // For Progress bar for document uploading on KYC section Start
  (function ($) {
    $.fn.bekeyProgressbar = function (options) {

      options = $.extend({
        animate: true,
        animateText: true
      }, options);

      var $this = $(this);

      var $progressBar = $this;
      var $progressCount = $progressBar.find('.ProgressBar-percentage--count');
      var $circle = $progressBar.find('.ProgressBar-circle');
      var percentageProgress = $progressBar.attr('data-progress');
      var percentageRemaining = (100 - percentageProgress);
      var percentageText = $progressCount.parent().attr('data-progress');

      //Calcule la circonférence du cercle
      var radius = $circle.attr('r');
      var diameter = radius * 2;
      var circumference = Math.round(Math.PI * diameter);

      //Calcule le pourcentage d'avancement
      var percentage = circumference * percentageRemaining / 100;

      $circle.css({
        'stroke-dasharray': circumference,
        'stroke-dashoffset': percentage
      })

      //Animation de la barre de progression
      if (options.animate === true) {
        $circle.css({
          'stroke-dashoffset': circumference
        }).animate({
          'stroke-dashoffset': percentage
        }, 3000)
      }

      //Animation du texte (pourcentage)
      if (options.animateText == true) {

        $({ Counter: 0 }).animate(
          { Counter: percentageText },
          {
            duration: 3000,
            step: function () {
              $progressCount.text(Math.ceil(this.Counter) + '%');
            }
          });

      } else {
        $progressCount.text(percentageText + '%');
      }

    };
    if ($(".ProgressBar").length > 0) {
      $('.ProgressBar').bekeyProgressbar();
      $('.ProgressBar').on('change', function () {
        $(this).bekeyProgressbar();
      })
    }
  })(jQuery);
  // For Progress bar for document uploading on KYC section End

  // For E-Sign on KYC section Start
  if ($("#sig-canvas").length > 0) {
    (function () {
      window.requestAnimFrame = (function (callback) {
        return window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60);
          };
      })();

      var canvas = document.querySelector("#sig-canvas");
      var esignContainer = document.querySelector('.kyc-box');
      var esignBtn = document.querySelector('#sendBtn');
      var clearBtn = document.querySelector("#resetBtn");
      var ctx = canvas.getContext("2d");
      ctx.strokeStyle = "#222222";
      ctx.lineWidth = 4;

      var drawing = false;
      var mousePos = {
        x: 0,
        y: 0
      };
      var lastPos = mousePos;

      canvas.addEventListener("mousedown", function (e) {
        drawing = true;
        lastPos = getMousePos(canvas, e);
      }, false);

      canvas.addEventListener("mouseup", function (e) {
        drawing = false;
      }, false);

      canvas.addEventListener("mousemove", function (e) {
        mousePos = getMousePos(canvas, e);
      }, false);

      // Add touch event support for mobile
      canvas.addEventListener("touchstart", function (e) {

      }, false);

      canvas.addEventListener("touchmove", function (e) {
        var touch = e.touches[0];
        var me = new MouseEvent("mousemove", {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        canvas.dispatchEvent(me);
      }, false);

      canvas.addEventListener("touchstart", function (e) {
        mousePos = getTouchPos(canvas, e);
        var touch = e.touches[0];
        var me = new MouseEvent("mousedown", {
          clientX: touch.clientX,
          clientY: touch.clientY
        });
        canvas.dispatchEvent(me);
      }, false);

      canvas.addEventListener("touchend", function (e) {
        var me = new MouseEvent("mouseup", {});
        canvas.dispatchEvent(me);
      }, false);

      function getMousePos(canvasDom, mouseEvent) {
        var rect = canvasDom.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        }
      }

      function getTouchPos(canvasDom, touchEvent) {
        var rect = canvasDom.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        }
      }

      function renderCanvas() {
        if (drawing) {
          ctx.moveTo(lastPos.x, lastPos.y);
          ctx.lineTo(mousePos.x, mousePos.y);
          ctx.stroke();
          lastPos = mousePos;
          canvas.classList.add('active');
          esignBtn.disabled = false;
          clearBtn.disabled = false;
        }
      }

      // Prevent scrolling when touching the canvas
      document.body.addEventListener("touchstart", function (e) {
        if (e.target == canvas) {
          e.preventDefault();
        }
      }, false);
      document.body.addEventListener("touchend", function (e) {
        if (e.target == canvas) {
          e.preventDefault();
        }
      }, false);
      document.body.addEventListener("touchmove", function (e) {
        if (e.target == canvas) {
          e.preventDefault();
        }
      }, false);

      (function drawLoop() {
        requestAnimFrame(drawLoop);
        renderCanvas();
      })();

      function clearCanvas() {
        canvas.width = canvas.width;
      }

      // Set up the UI
      clearBtn.addEventListener("click", function (e) {
        clearCanvas();
        esignContainer.setAttribute("data-src", '');
        esignBtn.disabled = true;
        clearBtn.disabled = true;
      }, false);
      esignBtn.addEventListener("click", function (e) {
        var dataUrl = canvas.toDataURL();
        esignContainer.setAttribute("data-src", dataUrl);
      }, false);

    })();
  }
  // For E-Sign on KYC section End

  // For Show and Hide on FAQ and Service section Start
  if ($(".FAQ-section").length > 0) {
    $(".FAQ-section .item-row:nth-child(n+5)").hide();
    $(".show_hide").on("click", function (e) {
      e.preventDefault();
      var txt = $(".FAQ-section .item-row:nth-child(n+5)").is(':visible') ? 'Show All' : 'Show Less';
      $(".show_hide").text(txt);
      $(this).parents('.FAQ-section').find('.item-row:nth-child(n+5)').slideToggle(300);
    });
  }
  if ($(".service-section").length > 0) {
    $(".service-section .item-row:nth-child(n+7)").hide();
    $(".show_hide").on("click", function (e) {
      e.preventDefault();
      var txt = $(".service-section .item-row:nth-child(n+7)").is(':visible') ? 'Show All' : 'Show Less';
      $(".show_hide").text(txt);
      $(this).parents('.service-section').find('.item-row:nth-child(n+7)').slideToggle(300);
    });
  }

  // if ($(".followup-section").length > 0) {
  //   $(".read-more").on("click", function (e) {
  //     e.preventDefault();
  //     var $this =$(this);
  //     var txt = $this.hasClass('active') ? 'Read More':'Read Less';
  //     if ($this.parents('.item').hasClass('active')) {
  //       // $this.parents('.item').siblings().removeClass('active').find('.post-des').removeClass('active');
  //       // $this.parents('.item').siblings().find('.read-more').removeClass('active');
  //       $this.parents('.item').find('.post-des').removeClass('active');
  //       $this.parents('.item').removeClass('active');
  //       $this.removeClass('active');
  //     } else {
  //       $this.parents('.item').siblings().removeClass('active').find('.post-des').removeClass('active');
  //       $this.parents('.item').siblings().find('.read-more').removeClass('active');
  //       $this.parents('.item').find('.post-des').toggleClass('active');
  //       $this.parents('.item').toggleClass('active');
  //       $this.toggleClass('active');
  //     }
  //     $($this).find('.link_text').text(txt);      
  //   });
  // }
  // For Show and Hide on FAQ and Service section End
  
  //For footer script start
  if ($(".important-links").length > 0) {
    $(".important-links-list a:nth-child(n+5)").hide();
    $(".show_hide").on("click", function (e) {
      e.preventDefault();
      var txt = $(".important-links-list a:nth-child(n+5)").is(':visible') ? 'Show More' : 'Show Less';
      $(".show_hide").text(txt);
      $(this).parents('.important-links').find('.important-links-list a:nth-child(n+5)').slideToggle(300);
    });
  }
  $('.footer-links h3').click(function () {
    $(this).parent('.box').toggleClass('show').siblings('.box').removeClass('show');
  });
  //For footer script end

  function remEl() {
    var viewportWidth = $(window).width();
    if (viewportWidth < 768) {
      // console.log('viewport is grater than 768');
      $(".payment-col-right .pay-now.show-md").remove();
    } else if (viewportWidth > 767) {
      // console.log('viewport is less than 767');
      $(".notification-overlay.hide-md").remove();
    }
  }
  //  remEl(); 

  // Some variable use in document scroll event
  const scrollBtn = document.querySelector(".scroll-top");
  const winWidth = document.body.clientWidth;
  if ($('.payment-col-right-inner').length > 0) {
    var path = $('.payment-col-right-inner'),
      sidebarOffset = $('.payment-col-right-inner').offset().top,
      content_height = $('.payment-col-left').outerHeight(true),
      stickyHeadHeight = $('.header-section').outerHeight(true),
      stickyContentWidth = path.innerWidth(),
      stickyContentHeight = path.outerHeight(true),
      mar_top = content_height - path.outerHeight(true),
      total = (content_height + sidebarOffset) - stickyContentHeight - stickyHeadHeight;
    // console.log(content_height);
  }
  $(scrollBtn).click(function () {
    $("html, body").animate({
      scrollTop: 0
    }, "slow");
    return false;
  });

  window.onscroll = function () {
    if ($("#mainHeader").length > 0) {
      var header = document.getElementById("mainHeader");
      var sticky = header.offsetTop;
      function stickyHeader() {
        sticky = header.offsetTop;
        if (window.pageYOffset > sticky) {
          header.classList.add("sticky");
        } else {
          header.classList.remove("sticky");
        }
      }
      stickyHeader();
    }

    if ($(".scroll-top").length > 0) {
      // When the user scrolls down 100px from the top of the document, show the button      
      function scrollFunction() {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
          document.querySelector("body").classList.add('active-sctop-btn');
          scrollBtn.classList.add('showBtn');
        } else {
          document.querySelector("body").classList.remove('active-sctop-btn');
          scrollBtn.classList.remove('showBtn');
        }
      }
      scrollFunction();
    }

    if ($("#joinTheClubOnBanner").length > 0) {
      //Get the button:
      var joinClubBtnDesk = $("#join-club-btn-desktop");
      var joinClubBtnMob = $("#join-club-btn-mobile");
      const bannerOnLandingPage = $("#bt-slider");
      const bannerOnLandingPageHeight = $(bannerOnLandingPage).height();
      // console.log(winWidth);
      // When the user scrolls down 100px from the top of the document, show the button      
      function joinClubBtnFunction() {
        if (document.body.scrollTop > bannerOnLandingPageHeight || document.documentElement.scrollTop > bannerOnLandingPageHeight) {
          if (winWidth > 1024) {
            $(joinClubBtnDesk).parents('.right-section').addClass('join-club-btn-show');
            $(joinClubBtnDesk).removeAttr('hidden');
          } else {
            $(joinClubBtnMob).parents('.left-section').addClass('join-club-btn-show');
            $(joinClubBtnMob).removeAttr('hidden');
          }
        } else {
          $(joinClubBtnDesk).parents('.right-section').removeClass('join-club-btn-show');
          $(joinClubBtnMob).parents('.left-section').removeClass('join-club-btn-show');
          $(joinClubBtnDesk).attr('hidden', '');
          $(joinClubBtnMob).attr('hidden', '');
        }
      }
      joinClubBtnFunction();
    }

    if ($('.payment-col-right-inner').length > 0) {
      var winScrollTop = $(window).scrollTop();
      // console.log('total == ', total, 'sidebarOffset = ', sidebarOffset, 'content_height = ', content_height, 'stickyHeadHeight == ', stickyHeadHeight, 'winScrollTop  == ', winScrollTop);

      function stickySidebar() {
        if (winWidth >= 1024 && stickyContentHeight < content_height) {
          if ((winScrollTop >= (sidebarOffset - stickyHeadHeight))) {
            path.addClass('payment-sticky').removeClass('sticky-remove');
            path.css({
              'top': sidebarOffset + 'px',
              'width': stickyContentWidth + 'px',
              'marginTop': ''
            });
          }
          if (winScrollTop >= total) {
            // console.log(total);
            path.removeClass('payment-sticky').addClass('sticky-remove');
            path.css({
              'top': '',
              'marginTop': mar_top + 'px'
            });
          }
        }
      }
      stickySidebar();
    }
  }
  
  /** JS STRTS */
    $('#bt-slider1').owlCarousel({
        stagePadding: 100,
        loop:true,
        margin:0,
        nav:true,
        items:1,
        lazyLoad: true,
        autoplay:true,
        autoplaySpeed: 1000,
        autoplayTimeout:11000,
        navText: [
          "<img src='" + assetBaseUrl + "images/banner-arrow.svg'>",
          "<img src='" + assetBaseUrl + "images/banner-arrow.svg'>"
        ],
      responsive:{
            0:{
                items:1,
                stagePadding: 0,
                margin:5,
            },
            800:{
                items:1,
                stagePadding: 40,
            },
            1000:{
                items:1,
                stagePadding: 100,
            },
            1400:{
                items:1,
                stagePadding: 100,
            },
            1800:{
                items:1,
                stagePadding: 100,
            }
        }
    })

    // $('#small-slider2').owlCarousel({
    //   loop:true,
    //   margin:30,
    //   nav:false,
    //   dots:true,
    //   items:1,
    //   lazyLoad: true,
    //   autoplay:true,
    //   autoplaySpeed: 1000,
    //   autoplayTimeout:11000,
    // responsive:{
    //       0:{
    //           items:1,
    //           margin:5,
    //       },
    //       800:{
    //           items:1,
    //       },
    //       1000:{
    //           items:1,
    //       },
    //       1400:{
    //           items:1,
    //       },
    //       1800:{
    //           items:1,
    //       }
    //   }
    // });
    $(".minslider").owlCarousel({
        nav: !1,
        dots: !1,
        margin: 0,
        autoWidth: !1,
        loop:true,
        responsive: { 0: { items: 3, nav: !0 , touchDrag:false },820: { items: 3, nav: !0 }, 1025: { items: 3, nav: !0 } },
    })
   
    $("#lifetime-slides").owlCarousel({
        nav: !1,
        dots: !1,
        items: 6,
        margin: 5,
        autoWidth: !0,
        navText: ["<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>", "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"],
        responsive: { 0: { items: 1.2 }, 1025: { items: 3.5, nav: !0 } },
        onTranslate: e,
        onDraged: e,
        onInitialized: s,
        onRefresh: a,
    })

  //   $("#benefits-slider").owlCarousel({
  //     nav: true,
  //     dots: true,
  //     items: 1,
  //     margin: 5,
  //     loop:true,
  //     autoWidth: !0,
  //     navText: ["<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>", "<img src='" + assetBaseUrl + "images/arrow-navy-blue.svg'>"],
  //     responsive: { 0: { items: 1 }, 1025: { items: 3.5, nav: !0 } },
  //     onTranslate: e,
  //     onDraged: e,
  //     onInitialized: s,
  //     onRefresh: a,
  // })
       

    /** JS ENDs */
});
